import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/mui";
import { Stack, Typography, Alert } from "@mui/material";

import { DetailSection, FieldGrid, FieldItem } from "components/detail";

export const BlockUserShow = () => {
    const { queryResult } = useShow();
    const { data, isLoading, isError } = queryResult;
    const record = data?.data;

    return (
        <Show
            isLoading={isLoading}
            title={
                <Typography variant="h5">
                    차단된 사용자 상세{record?.id ? ` · ${record.id}` : ""}
                </Typography>
            }
        >
            {isError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    차단된 사용자 정보를 불러오지 못했습니다.
                </Alert>
            )}

            <Stack spacing={2}>
                <DetailSection title="기본 정보">
                    <FieldGrid columns={2}>
                        {/* blockUserColumns.tsx와 동일한 필드/라벨(issue #69: 기존 필드는 무관한 회원 프로필 화면을 복붙한 것이었음) */}
                        <FieldItem label="차단한 사용자 ID" value={record?.blockingUserId} />
                        <FieldItem label="차단된 사용자 ID" value={record?.blockedUserId} />
                        <FieldItem label="생성일" value={record?.createdDate} />
                        <FieldItem label="수정일" value={record?.updatedDate} />
                    </FieldGrid>
                </DetailSection>
            </Stack>
        </Show>
    );
};
